const defaultConfig = {
  name: 'Discador.NET',
  logoUrl: '/brand-logo.png',
  theme: {
    primaryColor: '#4f46e5',
    secondaryColor: '#22c55e',
    backgroundColor: '#020817',
    textColor: '#f9fafb',
  },
};

export function getBrandConfig() {
  if (typeof window !== 'undefined' && window.__BRAND_CONFIG__) {
    return {
      ...defaultConfig,
      ...window.__BRAND_CONFIG__,
      theme: {
        ...defaultConfig.theme,
        ...(window.__BRAND_CONFIG__.theme || {}),
      },
    };
  }
  return defaultConfig;
}

